import { createFileRoute } from "@tanstack/react-router";
import { BillingPage } from "@/components/billing/billing-page";

export const Route = createFileRoute("/_dashboard/billing")({
  component: BillingPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    purchaseCredits?: boolean;
  } => {
    return {
      purchaseCredits: search.purchaseCredits === true || search.purchaseCredits === "true",
    };
  },
});
